import { ReactNode } from 'react';
import { cn, combineIssues, severityStyle } from '../../../../utils';
import { ErrorEntry } from '../../../../components/errors';
import type { ValidationIssue } from '../../../../types';

interface FormatterErrorProps {
  issues: ValidationIssue[] | undefined;
}

/**
 * Inline severity-coloured message used by formatters to surface validation
 * issues next to or below their content. Delegates the message text to
 * `ErrorEntry` so `meta.expected` / `meta.actual` are formatted consistently
 * with the rest of the toolkit. Renders nothing when there are no issues.
 */
export function FormatterError({ issues }: FormatterErrorProps): ReactNode {
  const combined = combineIssues(issues);
  const sev = severityStyle(combined?.severity);
  if (!combined || !sev) return null;
  return (
    <span className={cn('flex items-start gap-xs text-xs', sev.iconColor)}>
      <span>
        <ErrorEntry issue={combined} />
      </span>
    </span>
  );
}
